import { useState, useEffect } from "react";
import {
  Divider,
  Row,
  Col,
  Form,
  InputNumber,
  DatePicker,
  Flex,
  Button,
  Descriptions,
  Typography,
  message,
} from "antd";
import { Table } from "antd";
import { notEnter } from "../../../utils/util";

import { RiDeleteBin5Line } from "react-icons/ri";
import { TbTrash } from "react-icons/tb";
import dayjs from "dayjs";
import { componentsEditable, columnsParametersEditable } from "./model";
// import useConfirm from '../../../store/hook/use-confirm.hook';
// const dateFormat = 'DD/MM/YYYY';

export default function ManageFormExpiryDate({
  data,
  submit,
  name = "form-data",
}) {
  const dividerProp = {
    orientation: "left",
    style: { marginBlock: 10 },
    className: "!border-black",
  };
  const formRole = { required: true, message: "กรุณากรอกข้อมูลให้ครบถ้วน!" };

  // const confirms = useConfirm();

  const [form] = Form.useForm();
  const values = Form.useWatch([], form);

  const [listDetail, setListDetail] = useState([]);

  const [totalqty, setTotalQty] = useState(0);

  useEffect(() => {
    const init = () => {
      form.setFieldsValue(data);
      /* ไม่ตั้งวันที่ตั้งต้นให้ — ผู้ใช้กรอกวันที่ผลิต/วันหมดอายุเอง */

      const expires = Array.isArray(data?.expire)
        ? data.expire
        : data?.expire
        ? [data.expire]
        : [];

      const sumlist_qty = expires.reduce(
        (a, b) => a + (Number(b?.list_qty || b?.expire_qty) || 0),
        0
      );
      setListDetail(data?.expire);

      setTotalQty(data?.qty - sumlist_qty || 0);

      // setTotalQty(sumlist_qty);
    };

    init();
    return () => {};
  }, [data, form]);

  const handleSave = (row) => {
    const newData = (r) => {
      const newData = [...listDetail];

      const ind = newData.findIndex((item) => r?.seq === item?.seq);
      if (ind < 0) return newData;

      const item = newData[ind];
      const patch = { ...r };

      /* แก้วันที่ผลิต → คำนวณวันหมดอายุใหม่จาก shelf life ของสินค้า
         (แก้วันหมดอายุเองทีหลังได้ ระบบจะไม่เขียนทับ) */
      if (r?.key === "mfg_date" && r?.mfg_date) {
        const shelfLife = Number(data?.shelf_life || 0);
        patch.expire_date = dayjs(r.mfg_date)
          .add(shelfLife, "day")
          .format("YYYY-MM-DD");
      }

      newData.splice(ind, 1, { ...item, ...patch });
      return newData;
    };
    setListDetail([...newData(row)]);
  };

  const handleAddNew = (newItem) => {
    setListDetail((prev) => [...prev, newItem]);
  };

  const handleCreateList = async (mode = 0) => {
    try {
      const mfgDate = form.getFieldValue("mfgdate") || null;
      if (mode) {
        if (
          !form.getFieldValue("rqty") ||
          form.getFieldValue("rqty") <= 0 ||
          isNaN(form.getFieldValue("rqty"))
        ) {
          message.error("กรุณาระบุจำนวนรับให้ถูกต้อง");
          return;
        }
        // อนุญาตให้รับเกินจำนวนที่สั่งได้ — แค่เตือนให้ทราบ
        if (totalqty < Number(form.getFieldValue("rqty"))) {
          message.warning("รับเกินจำนวนที่สั่งซื้อ");
        }
        handleAddNew({
          seq: listDetail.length + 1,
          stock_date: dayjs(data?.stock_date).format("YYYY-MM-DD"),
          mfg_date: mfgDate ? mfgDate.format("YYYY-MM-DD") : null,
          list_qty: Number(form.getFieldValue("rqty")),
          /* คำนวณวันหมดอายุให้เฉพาะตอนที่ผู้ใช้กรอกวันที่ผลิตมาแล้ว */
          expire_date:
            mfgDate && Number(data?.shelf_life || 0) > 0
              ? dayjs(mfgDate).add(data.shelf_life, "day").format("YYYY-MM-DD")
              : null,
          // เพิ่ม field อื่นๆ ตามต้องการ
        });
        setTotalQty(totalqty - Number(form.getFieldValue("rqty")));
      } else {
        let total = totalqty;
        if (total <= 0) {
          message.error("รับครบตามจำนวนที่สั่งแล้ว หากต้องการรับเพิ่ม ให้ระบุจำนวนแล้วกด \"รับ\"");
          return;
        }
        handleAddNew({
          seq: listDetail.length + 1,
          stock_date: dayjs(data?.stock_date).format("YYYY-MM-DD"),
          mfg_date: mfgDate ? mfgDate.format("YYYY-MM-DD") : null,
          list_qty: Number(total),
          /* คำนวณวันหมดอายุให้เฉพาะตอนที่ผู้ใช้กรอกวันที่ผลิตมาแล้ว */
          expire_date:
            mfgDate && Number(data?.shelf_life || 0) > 0
              ? dayjs(mfgDate).add(data.shelf_life, "day").format("YYYY-MM-DD")
              : null,
          // เพิ่ม field อื่นๆ ตามต้องการ
        });
        setTotalQty(totalqty - total);
      }
    } catch (e) {
      console.log(e);
      // confirms.error("เกิดข้อผิดพลาด ทำรายการไม่สำเร็จ");
    }
  };

  const onSubmit = () => {
    // const totalReceived = (listDetail || []).reduce(
    //   (acc, v) => acc + (Number(v?.list_qty || v?.expire_qty) || 0),
    //   0
    // );
    /* ตัด key ทิ้งก่อนส่งกลับ
       key เป็นร่องรอยของช่องที่เพิ่งแก้ในตารางหลัก (เช่น "qty") ที่ติดมากับ row
       ถ้าปล่อยไป หน้าหลักจะเข้าใจว่านี่คือการแก้จำนวน แล้วสร้าง lot ใหม่ทับ
       วันหมดอายุที่เพิ่งตั้งไว้ทั้งหมด */
    const { key: _ignoredKey, ...rest } = data || {};

    const payload = {
      ...rest,
      expire: Array.isArray(listDetail) ? listDetail : [],
      // recamount: totalReceived,
    };
    // console.log("submit payload:", payload);
    if (typeof submit === "function") submit(payload);
  };

  const handleDelete = (code) => {
    setListDetail((prev) => {
      const updated = prev.filter((item) => item?.seq !== code);
      const sumUpdated = updated.reduce(
        (acc, v) => acc + (Number(v?.list_qty || v?.expire_qty) || 0),
        0
      );
      // คงเหลือ = จำนวนที่จะรับทั้งหมด - ผลรวมรายการที่มีอยู่ (ติดลบได้ = รับเกิน)
      setTotalQty(Number(data?.qty || 0) - sumUpdated);
      return updated;
    });
  };

  const handleAction = (record) => {
    const itemDetail = [...listDetail];
    return itemDetail.length >= 1 ? (
      <Button
        className="bt-icon"
        size="small"
        danger
        icon={
          <RiDeleteBin5Line style={{ fontSize: "1rem", marginTop: "3px" }} />
        }
        onClick={() => handleDelete(record?.seq, record?.list_qty)}
        disabled={!record?.seq}
      />
    ) : null;
  };

  const masterItems = [
    { label: "รหัสสินค้า", children: data?.stcode },
    {
      label: "ชื่อสินค้า",
      children: data?.stname,
      span: { xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 },
    },
    { label: "วันหมดอายุ", children: data?.shelf_life + " วัน" },
    {
      label: "จำนวนที่สั่งซื้อ",
      children: data?.qty_buy,
      span: { xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 },
    },
    { label: "จำนวนที่จะรับ", children: data?.qty },
    {
      label: "คงเหลือ",
      children:
        totalqty < 0 ? (
          <Typography.Text type="danger" strong>
            {totalqty} (รับเกิน {Math.abs(totalqty)})
          </Typography.Text>
        ) : (
          totalqty
        ),
    },
  ];

  const receipt_info = (
    <>
      <Divider {...dividerProp}>ข้อมูลรายการสั่งซื้อ</Divider>
      <Descriptions
        bordered
        column={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3, xxl: 3 }}
        items={masterItems}
      />
    </>
  );

  /* ช่องนี้เดิมมีป้ายว่า "วันที่รับสินค้า" แต่จริง ๆ คือวันที่ผลิตตั้งต้น
     ที่ใช้ตอนกด "รับ"/"รับทั้งหมด" (mfg_date ของแถวใหม่ และใช้บวก shelf life
     ออกมาเป็นวันหมดอายุ) ไม่เกี่ยวกับวันที่รับของเข้าสต๊อกซึ่งมาจาก er_grmaster.grdate

     ป้ายทำให้ผู้ใช้สับสน จึงซ่อนไว้ และไม่ตั้งค่าเริ่มต้นให้
     ผู้ใช้กรอกวันที่ผลิตรายแถวเองจากคอลัมน์ "วันที่ผลิต (Supplier)" ในตาราง */
  const information_date = (
    <Form.Item name="mfgdate" hidden>
      <DatePicker />
    </Form.Item>
  );

  const information_qty = (
    <>
      <Row className="!mx-0" gutter={[8, 8]}>
        <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
          <Form.Item label="ระบุจำนวนรับ :" name="rqty" htmlFor="rqty">
            <Flex className="w-full justify-between gap-2" name="test">
              <InputNumber
                id="rqty"
                name="rqty"
                value={form.getFieldValue("rqty")}
                style={{ width: "75%" }}
                className="input-40"
                controls={false}
                placeholder="กรอกระบุจำนวนรับ"
                onFocus={(e) => e.target.select()}
                min={1}
              />
              <Button
                icon={<TbTrash style={{ fontSize: "1rem" }} />}
                className="bn-center bn-primary-outline"
                onClick={() => handleCreateList(1)}
              >
                รับ
              </Button>
              <Button
                icon={<TbTrash style={{ fontSize: "1rem" }} />}
                className="bn-center bn-success-outline"
                onClick={() => handleCreateList(0)}
              >
                รับทั้งหมด
              </Button>
            </Flex>
          </Form.Item>
        </Col>
      </Row>
    </>
  );

  /** setting column table */
  const prodcolumns = columnsParametersEditable(handleSave, {
    handleAction,
    /* วันที่ใบสั่งซื้อของสินค้ารายการนี้ — มาจาก er_pomaster.podate */
    podate: data?.podate,
  });

  const list_receipt = (
    <>
      <Divider {...dividerProp}>รายการสินค้าที่รับ</Divider>
      <Table
        // title={() => TitleTable}
        components={componentsEditable}
        rowClassName={() => "editable-row"}
        bordered
        dataSource={listDetail}
        columns={prodcolumns}
        pagination={false}
        rowKey="seq"
        scroll={{ x: "max-content" }}
        locale={{
          emptyText: <span>No data available, please add some data.</span>,
        }}
      />
    </>
  );
  return (
    <>
      <Form
        id="form-product-expiry"
        form={form}
        layout="vertical"
        name={name}
        autoComplete="off"
        className="w-full"
        // onValuesChange={(_, value)=> setFormValue(value)}
        onKeyDown={notEnter}
        onFinish={onSubmit}
      >
        {receipt_info}
        {information_date}
        {list_receipt}
        {information_qty}
      </Form>
    </>
  );
}
